// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QGS06","container_mobile":"styles_container_mobile__+PHvK","advertisement":"styles_advertisement__hNI1Y"};